<template>
	<div class="contentPage">
		<main-table
				v-if="workOrdersFilter"
				:flag="flag"
				:uniqId="uniqId"
				pageTitle='Work orders'
				:headers="headers"
				:listItems="workOrdersList"
				:filtersList="workOrdersFilter"
				:defaultFilter="workOrdersFilterDefault"
				defaultSortBy="id"
				textCreate="Add work order"
				@updateClickButton="onClickButton"
				@updateCreate="onCreate"
				@updateEdit="onEditMain"
				@updateCounter="onCounter"
				@updateSearch="onFilter"
				@updateRefreshFilters="onFilter"
				@updateChangeSort="onFilter"
				@updateExport="onExport"
				@updateSettings="onSettingsOpen"
				:settings="getSettings"
				is-settings
				is-export
		></main-table>
		<add-work-orders
				v-if="isWorkOrders"
				:currentId="currentId"
				:getPermissionAction="getPermissionAction"
				:permissions="permissions"
				@updateClose="onAddWorkOrder(false)"
				@updateFilterList="onFilterList"
		></add-work-orders>
		<remove-block v-if="isRemove" @updateRemoveItem="onRemoveItem" @updateRemoveClose="onRemoveClose"></remove-block>
		<comments-popup
				v-if="isCommentsPopup"
				:commentsList="commentsList"
				:commentsData="commentsData"
				@updateCloseComments="onCloseComments"
		></comments-popup>
		<table-settings
				v-if="isTableSettingsDrawer"
				@updateSettingsSave="onSettingsSave('work-order')"
				@updateSettingsCancel="onSettingsCancel"
				@updateSettingsClose="onSettingsClose"
				@updateSettingsAll="onSettingsAll"
				:settings="settings"
		></table-settings>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// async components
const AddWorkOrders = () => import("@/components/Fleet/WorkOrders/AddWorkOrders/AddWorkOrders");
const CommentsPopup = () => import("@/components/Fleet/WorkOrders/CommentsPopup/CommentsPopup");
const RemoveBlock = () => import("@/shared/RemoveBlock/RemoveBlock");
const TableSettings = () => import("@/shared/TableSettings/TableSettings");

// helper
import getUniqId from "@/helper/getUniqId";
import { PERMISSIONS } from "@/constants/constants";
import settingsMixins from "@/mixins/settingsMixins";

export default {
	name: "WorkOrders",
	mixins: [ settingsMixins ],
	components: {
		AddWorkOrders,
		CommentsPopup,
		RemoveBlock,
		TableSettings
	},
	computed: {
		...mapGetters([
			'workOrdersFilter',
			'workOrdersList',
			'permissions',
			'workOrdersFilterDefault',
			'workOrdersHeaders'
		]),
		getPermissionAction() {
			if ((this.permissions[PERMISSIONS.CREATE] && !this.currentId) || this.permissions[PERMISSIONS.EDIT]) return false;
			return this.permissions[PERMISSIONS.VIEW];
		},
		isExport() {
			return this.permissions[PERMISSIONS.EXPORT];
		},
	},
	data: () => ({
		flag: 'workOrders',
		isRefresh: null,
		isFilterList: null,
		commentsData: null,
		isWorkOrders: false,
		currentId: null,
		isRemove: false,
		removeId: null,
		isCommentsPopup: false,
		commentsList: [],
		isTableSettingsDrawer: false,
		ssss: { filter_status: [] }
	}),
	methods: {
		...mapActions([
			'onWorkOrdersStart',
			'onWorkOrders',
			'onRemoveWorkOrder',
			'onWorkOrderComments',
			'onClearWOFilter',
			'onExportLink',
			'onWorkOrdersFilter'
		]),
		async onExport(values) {
			await this.onExportLink({ values, requestKey: 'work-order' });
		},
		async onFilter(info) {
			this.filterModList = info.filterModList;
			await this.onWorkOrdersFilter(info.filterModList);
		},
		onClickButton({ key, item }) {
			if (key === "delete") {
				this.getRemoveItem(item.id);
			}
		},
		onCreate() {
			this.currentId = null;
			this.isWorkOrders = true;
		},
		onCounter(value) {
			const { flag, line } = value;
			if (flag === "dispatch_request") {
				const { id, unit, unit_type } = line;
				this.onCommentsPopup({ id, unit, unit_type });
			}
		},
		onEditMain(onValue) {
			if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW]) {
				this.currentId = onValue.line.id;
				this.isWorkOrders = true;
			}
		},
		refreshFilters() {
			this.isRefresh = getUniqId();
		},
		onFilterList() {
			this.isFilterList = getUniqId();
		},
		onRemoveClose() {
			this.isRemove = false;
		},
		onAddWorkOrder(value) {
			this.currentId = null;
			this.isWorkOrders = value;
		},
		onEdit(id) {
			if (this.permissions[PERMISSIONS.EDIT] || this.permissions[PERMISSIONS.VIEW]) {
				this.currentId = id;
				this.isWorkOrders = true;
			}
		},
		async onCommentsPopup({ id, unit, unit_type }) {
			this.commentsData = { unit, unit_type };
			this.commentsList = await this.onWorkOrderComments(id);
			this.isCommentsPopup = true;
		},
		onCloseComments() {
			this.isCommentsPopup = false;
		},
		getRemoveItem(id) {
			this.removeId = id;
			this.isRemove = true;
		},
		async onRemoveItem() {
			await this.onRemoveWorkOrder(this.removeId);
			this.isRemove = false;
		}
	},
	async mounted() {
		await this.onWorkOrdersStart(null);
	},
	destroyed() {
		this.onClearWOFilter();
	}
};
</script>

